import { Actions } from '../../components/product-table/columns/actions-column';
import { ItemCode } from '../../components/product-table/columns/item-code-column';
import { ProductNameWithLabels } from '../../components/product-table/columns/product-name-with-labels-column';
import { QOH } from '../../components/product-table/columns/qoh-column';
import { Reorder } from '../../components/product-table/columns/reorder-column';
import { getUnitsSoldColumn } from '../../components/product-table/columns/sales-columns';
import { Type } from '../../components/product-table/columns/simple-columns';
import { Size } from '../../components/product-table/columns/size-column';
import { VendorName } from '../../components/product-table/columns/vendor-name-column';
import { HideDisabledFilter } from '../../components/product-table/filters/hide-disabled-filter';
import { ProductReport } from '../../components/product-table/product-report';
import type { StrictColumnDef } from '../../components/tanstack-table/column';
import type { Product } from '../../data/product';
import { productReportsLayout } from '../../router';

const columns: StrictColumnDef<Product>[] = [
  VendorName,
  ItemCode,
  ProductNameWithLabels,
  Type,
  Size,
  QOH,
  getUnitsSoldColumn(90),
  Reorder,
  Actions,
];

const defaultFilters = { maximumInventory: -1 };

export function NegativeInventoryReport() {
  const products = productReportsLayout.useLoaderData();

  return (
    <ProductReport
      products={products}
      title="Negative Inventory"
      defaultFilters={defaultFilters}
      columns={columns}
      toolbarLeft={<HideDisabledFilter />}
    />
  );
}
